import React, { Component } from 'react'
import styles from './ProgramType.css'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import Option from '../Option'

class ProgramType extends Component {
  render () {
    return (
      <div className='top20'>
        <p className={styles['action-label']}>Choose the Loyalty Program you want to implement</p>
        <ListGroup>
          <ListGroupItem className={`${styles['active']} ${styles['program']} bottom10 cursor-pointer`}>
            <Option
              img={require('assets/images/rp.png')}
              title='Rp X = Y Point'
              body='Customers will get points for a certain amount of price they spend in one transaction.'
              isDisabled={false}
            />
          </ListGroupItem>
          <ListGroupItem className={`${styles['disabled']} bottom10 cursor-not-allowed`}>
            <Option
              img={require('assets/images/groceries.png')}
              title='Item X = Y Point (Coming Soon)'
              body='Customers will get points by purchasing specific item or any item in a category.'
              isDisabled
            />
          </ListGroupItem>
        </ListGroup>
        <button
          onClick={this._onClickNext}
          style={{color: '#3e8acc'}}
          className='btn btn-default pull-right'
        >
          Next
        </button>
      </div>
    )
  }

  _onClickNext = (e) => {
    e.stopPropagation()
    this.props.onFinish()
  }
}
export default ProgramType



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/ProgramType/ProgramType.js